import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ViewScheduleComponent } from './view-schedule.component';
import { BookingDetailsPopupComponent } from './booking-detail.component';
import { ViewScheduleRoutingModule} from './view-schedule.routing';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations:
    [
        ViewScheduleComponent,
        BookingDetailsPopupComponent
    ],
    imports: [ViewScheduleRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [],
    entryComponents: [BookingDetailsPopupComponent],
    bootstrap: []
})

export class ViewScheduleModule {}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/view-schedule.module.ts